import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const ServicesSection = () => {
  const services = [
    {
      id: 'itad',
      title: 'IT Asset Disposition',
      desc: 'Secure retirement of IT assets with certified data destruction and compliant disposal.',
      image: 'https://images.pexels.com/photos/546819/pexels-photo-546819.jpeg'
    },
    {
      id: 'ewaste',
      title: 'E-Waste Recycling',
      desc: 'Eco-friendly electronics recycling through certified facilities across the UAE.',
      image: 'https://images.pexels.com/photos/343457/pexels-photo-343457.jpeg'
    },
    {
      id: 'dismantling',
      title: 'Material Recovery',
      desc: 'Professional dismantling and component separation for maximum value recovery.',
      image: 'https://images.pexels.com/photos/1145434/pexels-photo-1145434.jpeg'
    },
    {
      id: 'rscm',
      title: 'Reverse Supply Chain',
      desc: 'End-to-end circular solutions for OEMs and manufacturers.',
      image: 'https://images.pexels.com/photos/209251/pexels-photo-209251.jpeg'
    }
  ];

  return (
    <section className="py-20 lg:py-24 bg-[#f8fafc]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <p className="text-[#4fd1c5] text-sm font-semibold tracking-[0.15em] uppercase mb-3">
              Our Services
            </p>
            <h2 className="text-3xl lg:text-4xl font-light text-[#0a1628]">
              Comprehensive <span className="font-semibold">Circular Solutions</span>
            </h2>
          </div>
          <Link 
            to="/services" 
            className="inline-flex items-center gap-2 text-[#0a1628] font-semibold hover:text-[#4fd1c5] transition-colors duration-500 ease-out"
          >
            View All Services
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service) => (
            <Link 
              key={service.id}
              to={`/services#${service.id}`}
              className="group relative overflow-hidden bg-white transition-all duration-500 ease-out hover:shadow-lg"
              data-testid={`service-card-${service.id}`}
            >
              {/* Image */}
              <div className="aspect-[4/3] overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700 ease-out"
                />
              </div>
              
              {/* Content */}
              <div className="p-6">
                <h3 className="text-lg font-semibold text-[#0a1628] mb-2 group-hover:text-[#4fd1c5] transition-colors duration-500 ease-out">
                  {service.title}
                </h3>
                <p className="text-sm text-gray-500 mb-4">
                  {service.desc}
                </p>
                <span className="inline-flex items-center gap-1 text-sm font-semibold text-[#4fd1c5] opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-out">
                  Learn more <ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
